module.exports = __webpack_public_path__ + "media/images/website-b7917ff1aeefee2e17ac4eceeda8e390.png";